import React from 'react';
import { Phone } from 'lucide-react';

const WhatsAppButton = () => {
  const whatsappNumber = "5535988192707";
  const whatsappMessage = "Olá! Gostaria de mais informações sobre os serviços da Amanda Sales.";
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white w-16 h-16 rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform duration-300 hover:shadow-[0_0_30px_rgba(37,211,102,0.5)] group"
      aria-label="Contato via WhatsApp"
    >
      <Phone size={28} className="group-hover:rotate-12 transition-transform duration-300" />
      <span className="absolute -top-12 right-0 bg-[#033530] text-[#e8d6b2] px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-lg">
        Fale Conosco!
      </span>
    </a>
  );
};

export default WhatsAppButton;
